module.exports = __webpack_public_path__ + "img/icon2.1a7ceaef.png";